import React, { useState } from 'react';
import { Progress } from 'reactstrap';

interface IProps {
    value: number;
    style?: React.CSSProperties;
    className?: string;
    title?: string;
    type?: BarColor;
    showPercentage?: boolean;
}

export type BarColor = 'danger' | 'warning' | 'success' | 'persona' | 'sustainability' | 'packaging' | 'preference';

const SuitabilityBar: React.FC<IProps> = ({ value, style, className, title, type, showPercentage }) => {
    const [hover, setHover] = useState<boolean>(false);

    let color:BarColor = 'success';
    if (type === undefined) {
        color = value >= 50 ? 'success' : value >= 25 ? 'warning' : 'danger';
    } else {
        color = type;
    }

    return (
        <div data-tooltip={value} style={style} className={className} onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            {title !== " " && <small className="font-weight-normal color-battleship-grey">{ title || 'Preference'} </small>}
            <div className="d-flex align-items-center">
                <Progress value={value} className="rounded-pill flex-grow-1" style={{
                    boxShadow: 'none',
                    backgroundColor: "#E1ECF3",
                    marginRight: showPercentage ? '12px' : '0'
                }} color={color} />
                {showPercentage && (
                    <span className="font-weight-600 color-battleship-grey" style={{ fontSize: '13px', minWidth: '40px' }}>
                        {value.toFixed(0)}%
                    </span>
                )}
            </div>
        </div>
    );
};

export default SuitabilityBar;
